import { render, staticRenderFns } from "./BusinessOnboardingModel.vue?vue&type=template&id=545e9692&"
import script from "./BusinessOnboardingModel.vue?vue&type=script&lang=ts&"
export * from "./BusinessOnboardingModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports